/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { ShiftBusyTime, UserBusyTimes } from "@microsoft/shifts-models-data";
import { ShiftInfo } from "@microsoft/shifts-models-view";
// TODO: Replace 'sh-models' dependency from Web core with one from a workspace package.
import { ShiftStates, ShiftTypes } from "sh-models";

import { ICrossLocationShiftMapper } from "./ICrossLocationShiftMapper";

/**
 * The cross-location shift mapper.
 */
export class CrossLocationShiftMapper implements ICrossLocationShiftMapper {
    /**
     * Maps users shifts data models to shifts info view models.
     * @param usersShifts The users shifts data models to map.
     * @returns The shifts info view models.
     */
    public toShiftsInfo(usersShifts: UserBusyTimes[]): ShiftInfo[] {
        return usersShifts.reduce<ShiftInfo[]>((shifts, userShifts) => {
            const shiftsToAdd = userShifts.busyTime.map(shift => this.toShiftInfo(shift, userShifts.userId));

            return shifts.concat(shiftsToAdd);
        }, []);
    }

    /**
     * Maps a user shift data model to shift info view model.
     * @param shift The user shift data model.
     * @param userId The user id associated with the shift.
     * @returns The shift info view model.
     */
    private toShiftInfo(shift: ShiftBusyTime, userId: string): ShiftInfo {
        return {
            endTime: new Date(shift.endDateTime).getTime(),
            eTag: "",
            id: shift.id,
            shiftType: ShiftTypes.Working,
            startTime: new Date(shift.startDateTime).getTime(),
            state: ShiftStates.Active,
            teamId: shift.teamId,
            userId: userId
        };
    }
}
